export const getArticle = (word: string): string => {
	if (!word) {
		return '';
	}

	const vowels = new Set('aeiouAEIOU');
	return vowels.has(word[0]) ? 'an' : 'a';
};
